import { Injectable } from '@angular/core';

export enum StorageItemEnum {
  WidgetOptions = 'widgetOptions',
  Locale = 'locale',
  GroupRestriction = 'GroupRestriction',
  UserAppId = 'userAppId',
  RememberMeEmail = 'rememberMeEmail',
  LabelConversionSeen = 'labelConversionSeen',
  DefaultGroupEdit = 'defaultGroupEdit',
  DefaultCollectionId = 'defaultCollectionId'
}

export enum SessionStorageEnum {
  UserMessagesSeen = 'userMessagesSeen'
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  getLocalItem(key: StorageItemEnum) {
    return localStorage.getItem(`${key}`);
  }

  getLocalJSON(key: StorageItemEnum) {
    const value = this.getLocalItem(key);
    return value ? JSON.parse(value) : null;
  }

  setLocalItem(key: StorageItemEnum, value: any): boolean {
    const serializedValue = typeof (value) === 'object' ? JSON.stringify(value) : `${value}`;
    try {
      localStorage.setItem(`${key}`, serializedValue);
      return true;
    } catch (e) {
      return false;
    }
  }

  removeLocalItem(key: StorageItemEnum) {
    localStorage.removeItem(`${key}`);
  }

  getSessionItem<T>(key: SessionStorageEnum): T {
    const entry = sessionStorage.getItem(`${key}`);
    if (entry) {
      return <T>JSON.parse(entry);
    } else {
      return null;
    }
  }

  setSessionItem(key: SessionStorageEnum, entry: any): boolean {
    const json = JSON.stringify(entry);
    try {
      sessionStorage.setItem(`${key}`, json);
      return true;
    } catch (e) {
      return false;
    }
  }

  removeSessionItem(key: SessionStorageEnum) {
    sessionStorage.removeItem(`${key}`);
  }

  clearStorage() {
    this.clearLocalStorage();
    this.clearSessionStorage();
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  clearSessionStorage() {
    sessionStorage.clear();
  }
}
